'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Field, Textarea } from '@kiao-voice/ui-kit'

export interface UploadLinksFieldProps {
  value: string
  onChange: (value: string) => void
  disabled: boolean
  /** Usable links outside the media-platform list; they are tried as direct downloads. */
  offPlatformCount: number
}

/**
 * The 「貼上連結」 source: one media link per line. Validation happens when Start
 * is pressed (a half-typed URL is not an error yet); what shows while typing is
 * the support note and, for links outside the platform list, that they will be
 * fetched as plain files.
 */
export function UploadLinksField({
  value,
  onChange,
  disabled,
  offPlatformCount,
}: UploadLinksFieldProps) {
  const { t } = useTranslation('web')
  const fieldId = React.useId()
  return (
    <Field
      label={t('transcriptions.upload.linksLabel')}
      htmlFor={fieldId}
      hint={t('transcriptions.upload.linksHint')}
    >
      <Textarea
        id={fieldId}
        value={value}
        disabled={disabled}
        rows={4}
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        inputMode="url"
        placeholder={t('transcriptions.upload.linksPlaceholder')}
        onChange={(event) => onChange(event.target.value)}
      />
      {offPlatformCount > 0 ? (
        <p className="mt-2 text-xs leading-5 text-[var(--muted)]" data-testid="links-off-platform">
          {t('transcriptions.upload.linksOffPlatform', { count: offPlatformCount })}
        </p>
      ) : null}
    </Field>
  )
}
